export enum FilterKeyEnum {
  LIST_USER_FILTER = 'filter-list-user',
  COLABORATOR_FILTER = 'filter-colaborator',
  ATHLETE_FILTER = 'filter-athlete',
  SERVICE_PROVIDER_FILTER = 'competition-filter',
  TECHNICAL_COMITTEE_FILTER = 'filter-technical-comittee',
  LINK_SERVICE_FILTER = 'filter-link-sevice',
  TEACHING_INSTITUTION_FILTER = 'filter-teaching-institution',
  EVENT_FILTER = 'filter-event',
  COMPETITION_FILTER = 'filter-competition',
  SCHEDULED_REPORTS_FILTER = 'filter-scheduled-reports',
  STEP_PARAMETRIZATION_FILTER = 'filter-step-parametrization',
  COMPETITION_MODEL_FILTER = 'filter-competition-model',
  FILTER_GAMES_TABLE='filter-games-table',
  STATES_FILTER='states-filter',
  CITIES_FILTER='cities-filter',
  ARENAS_FILTER='arenas-filter',
  ROUND_MANAGEMENT_FILTER = 'round_management_filter',
}
